import { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogActions, DialogTitle, Slide, Stack, Tooltip } from "@mui/material";
import Header from "../../components/Header";
import DebFormModal from "../../components/DebFormModal";
import { DebFormSelect, DebFormTextInput } from "../../components/DebFormComponents";
import DataTable from "../../components/DataTable";
import { company as surveyCompany } from "../../services/companies";
import { mobileConnection as mobileConnectionService} from "../../services/mobile-connection";
import AddBoxIcon from "@mui/icons-material/AddBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "notistack";
import { mobileValidationSchema } from "../../schemas/mobile";
import { BugReport } from "@mui/icons-material";
import { MOBILE } from "../../constants/mobileConnectionTestSystems";

//TRANSICIÓN DEL ALERT DE ELIMINACIÓN
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const newMobileConnectionValues = {
    id: "",
    urlMobile: "",
    surveyCompany: {
        id: "",
    },
    userMobile: "",
    passwordMobile: "",
    tokenMobile: "",
};

const MobileConnections = () => {
    // MODAL DE EDICIÓN / CREACIÓN
    const [modalState, setModalState] = useState(false);
    const [modalInitialValues, setModalInitialValues] = useState(
        newMobileConnectionValues
    );
    const [mobileConnections, setMobileConnections] = useState([]);
    const [companies, setCompanies] = useState([]);

    const getMobileConnections = async () => {
        setMobileConnections(await mobileConnectionService.getAll());
    };
    const getCompanies = async () => {
        setCompanies(await surveyCompany.getAll());
    };

    useEffect(() => {
        getMobileConnections();
        getCompanies();
    }, []);

    const { enqueueSnackbar } = useSnackbar();

    const modifiedMobileConnections = [...mobileConnections].map((connection) => ({
        ...connection,
        surveyCompanyName: connection.surveyCompany.name
    }));

    const handleSubmit = async (values) => {
        try {
            if (values.id) {
                //estamos editando
                const res = await mobileConnectionService.update(values);
                enqueueSnackbar("Conexión editada", {
                    preventDuplicate: true,
                    variant: "success",
                });
            } else {
                const res = await mobileConnectionService.create(values);
                enqueueSnackbar("Conexión creada", {
                    preventDuplicate: true,
                    variant: "success",
                });
            }
            closeModal();
            getMobileConnections();
        } catch (error) {
            if (values.id) {
                enqueueSnackbar("Ocurrió un error al editar la conexión", {
                    preventDuplicate: true,
                    variant: "error",
                });
            } else {
                enqueueSnackbar("Ocurrió un error al crear la conexión", {
                    preventDuplicate: true,
                    variant: "error",
                });
            }
        }
    };

    const openModal = () => {
        setModalState(true);
    };

    const closeModal = () => {
        setModalState(false);
        setModalInitialValues(newMobileConnectionValues);
    };

    const handleEdit = (mobileConnection) => {
        setModalInitialValues(mobileConnection);
        openModal();
    };
    const handleCreateMobileConnection = () => {
        setModalInitialValues(newMobileConnectionValues);
        openModal();
    };

    const handleTest = async (mobileConnection) => {

        const mobileTestBody = {
        id: mobileConnection.id,
        url: mobileConnection.urlMobile,
        token: mobileConnection.tokenMobile,
        system: MOBILE
        };
        try {
            await mobileConnectionService.testConnection(mobileTestBody);
            enqueueSnackbar("Test OK", {
                preventDuplicate: true,
                variant: "success",
            });
        } catch (error) {
            let message = typeof error?.response?.data === "string" ? error?.response?.data : "Ocurrió un error inesperado."
            enqueueSnackbar(message, {
                preventDuplicate: true,
                variant: "error",
            });
        }
    };

      // ALERT DE ELIMINACIÓN
        const [selectedDelete, setSelectedDelete] = useState();
        const [openAlert, setOpenAlert] = useState(false);
        const handleAlertClose = () => {
            setOpenAlert(false);
        };
        const handleAlertOpen = (selectedMobileConnection) => {
            setSelectedDelete(selectedMobileConnection);
            setOpenAlert(true);
        };

    const handleDelete = async () => {
        try {
            await mobileConnectionService.delete(
                selectedDelete.id
            );
            enqueueSnackbar(
                "Se eliminó la conexión con " +
                    selectedDelete.urlMobile,
                {
                    preventDuplicate: true,
                    variant: "success",
                }
            );
            handleAlertClose();
            getMobileConnections();
        } catch (error) {
            enqueueSnackbar("Ocurrió un error eliminando la conexión", {
                preventDuplicate: true,
                variant: "error",
            });
        }
    };

    

    return (
        <Box>
            <Header
                title="CONEXIONES MÓBILES"
                subtitle="Lista de Conexiones Móbiles"
            />
            <DataTable
                loading={!mobileConnections.length}
                rows={modifiedMobileConnections}
                columns={[
                    { field: "id", headerName: "ID", flex: 0.1 },
                    {
                        field: "urlMobile",
                        headerName: "URL de Mobile",
                        flex: 0.7,
                        renderCell: (params) => (
                            <Tooltip title={params?.value ?? ""} arrow>
                                <span className="table-cell-trucate">
                                    {params?.value ?? ""}
                                </span>
                            </Tooltip>
                        ),
                    },
                    {
                        field: "surveyCompanyName",
                        headerName: "Compañía de encuestas",
                        flex: 0.7,
                        renderCell: (params) => (
                            <Tooltip title={params?.row?.surveyCompanyName ?? ""} arrow>
                                <span className="table-cell-trucate">
                                    {params?.row?.surveyCompanyName ?? ""}
                                </span>
                            </Tooltip>                  
                            )               
                    },
                    {
                        field: "userMobile",
                        headerName: "Usuario",
                        flex: 0.7,
                        renderCell: (params) => (
                            <Tooltip title={params?.value ?? ""} arrow>
                                <span className="table-cell-trucate">
                                    {params?.value ?? ""}
                                </span>
                            </Tooltip>
                        ),
                    },
                ]}
                rowActions={[
                    {
                        label: "Editar",
                        icon: <EditIcon />,
                        action: handleEdit,
                    },
                    {
                        label: "Eliminar",
                        icon: <DeleteIcon />,
                        action: handleAlertOpen,
                        showInMenu: true,
                    },
                    {
                        label: "Test",
                        icon: <BugReport />,
                        action: handleTest
                    },
                ]}
                headerActions={[
                    {
                        label: "Crear Conexión",
                        icon: <AddBoxIcon />,
                        action: handleCreateMobileConnection,
                    },
                ]}
            />

            {/* MODAL DE CREACIÓN / EDICIÓN DE CONEXIÓN MÓBIL */}
            <DebFormModal
                maxWidth="sm"
                fullWidth={true}
                open={modalState}
                onClose={closeModal}
                onReject={closeModal}
                initialValues={modalInitialValues}
                onSubmit={handleSubmit}
                formikProps={{
                    enableReinitialize: true,
                    validationSchema: mobileValidationSchema,
                }}
                headerText={
                    modalInitialValues?.id
                        ? "Editar Conexión"
                        : "Crear Conexión"
                }>
                <Stack spacing={1}>
                    <DebFormTextInput label={"URL Móbil"} name={"urlMobile"} />
                    <DebFormSelect
                        label={"Compañía de encuestas"}
                        name={"surveyCompany.id"}
                        selectOptions={Array.from(companies)?.map((surveyCompany) => {
                            return {
                                value: surveyCompany.id,
                                label: surveyCompany.name,
                            };
                        })}
                    />
                    <DebFormTextInput label={"Usuario"} name={"userMobile"} />
                    <DebFormTextInput
                        label={"Contraseña de servicio Mobile"}
                        name={"passwordMobile"}
                    />
                    <DebFormTextInput
                        label={"Token de servicio Mobile"}
                        name={"tokenMobile"}
                    />
                </Stack>
            </DebFormModal>

            {/* ALERT DE ELIMINACIÓN */}
            <Dialog
                open={openAlert}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleAlertClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle sx={{m:"2rem 3rem 1rem 3rem", gap:"1rem", p:"0"}} >{"¿Esta seguro que desea eliminar?"}</DialogTitle>
                <DialogActions>
                <Button onClick={handleAlertClose} variant="outlined" color="error">Cancelar</Button>
                <Button onClick={handleDelete} variant="contained" color="success">Confirmar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default MobileConnections;